import React from 'react';
import { styled } from 'styled-components';

import { formatDateShort, formatRelativeTime } from 'Compass/utils/orderUtils';

const RelativeTime = ({ date }: { date: string | number | undefined | null }) => {
  return <TimeSpan title={formatDateShort(date)}>
    {formatRelativeTime(date)}
  </TimeSpan>;
};

const TimeSpan = styled.span`
  cursor: default;
`;

export default RelativeTime;
